<template>
  <div>
    <Drawer title="新增流程" :closable="false" :width="width" v-model="openForm"
      :class="{ right350: openUser || openRole }">
      <div id="acewdsc">
        <Form ref="item" :model="item" :rules="ruleValidate" :label-width="80">
          <Row :gutter="16">
            <Col span="12">
            <FormItem label="流程名称" prop="name">
              <Input ref="sdsd" v-model="item.name" placeholder="请输入"></Input>
            </FormItem>
            <FormItem label="服务模块" prop="serverUrl">

              <Select v-model="item.serverUrl">
                <Option value="https://cloud.ly-gps.com/cloud-car-server-dpc/apply">车辆调度服务</Option>
                <Option value="https://cloud.ly-gps.com/cloud-common-server-cost/care">保养费用服务</Option>
                <Option value="https://cloud.ly-gps.com/cloud-common-server-cost/repair">维修费用服务</Option>
                <Option value="https://cloud.ly-gps.com/cloud-common-server-cost/peccancy">违章费用服务</Option>
                <Option value="https://cloud.ly-gps.com/cloud-common-server-cost/insur">保险费用服务</Option>
                <Option value="https://cloud.ly-gps.com/cloud-common-server-cost/refuel">加油费用服务</Option>
                <Option value="https://cloud.ly-gps.com/cloud-common-server-cost/pay">其他费用服务</Option>
              </Select>

            </FormItem>
            <FormItem label="单位名称" prop="groupName">
              <selectGroup :name="item.groupName" @update:name="item.groupName = $event" :id="item.groupId"
                @update:id="item.groupId = $event" :disabled="!isAdd">
              </selectGroup>
            </FormItem>
            <!--   <FormItem label="标签" prop="tag">
              <Select v-model="item.tag" multiple>
                <Option value="跳读">跳读</Option>
                <Option value="保养费用">保养费用</Option>
                <Option value="保险费用">保险费用</Option>
                <Option value="维修费用">维修费用</Option>
                <Option value="违章费用">违章费用</Option>
                <Option value="加油费用">加油费用</Option>
                <Option value="其他费用">其他费用</Option>
              </Select>
            </FormItem> -->
            <FormItem label="备注信息" prop="content">
              <Input ref="sdsd" v-model="item.content" placeholder="开发人员填写"></Input>
            </FormItem>
            <FormItem label="流程状态" prop="status">
              <RadioGroup v-model="item.status">
                <Radio :label="index" v-for="(x, index) in $t('flowStatus')" :key="index">{{ x }}</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="是否公用" prop="isPublic">
              <RadioGroup v-model="item.isPublic">
                <Radio :label="0" :key="0">否</Radio>
                <Radio :label="1" :key="1">是</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem label="版本号" prop="ver">
              <Input ref="sdsd" v-model="item.ver" placeholder="请输入"></Input>
            </FormItem>
            </Col>

            <Col span="12">
            <FormItem label="流程细节" prop="nodeList">
              <ul id="nodeList">
                <li v-for="(x, index) in item.nodeList" :key="index">
                  <h4 v-if="x.type == 0 || x.type == 2">
                    {{ x.name }}
                  </h4>
                  <Dropdown v-else placement="bottom-start">
                    <Input v-model="x.name" class="nodeListTitle"></Input>

                    <DropdownMenu slot="list" v-if="x.type == 1">
                      <DropdownItem><span @click="addPross(index)">插入节点</span>
                      </DropdownItem>
                      <DropdownItem v-show="x.type == 1">
                        <span @click="delPross(index)">删除节点</span>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>

                  <ly-form-item v-show="x.type == 1" label="说明" lw="2"><Input v-model="x.content"
                      class="nodeListContent" placeholder="请输入内容" ref="aaa" clearable></Input>
                  </ly-form-item>
                  <ly-form-item v-show="x.type == 1" label="用户" lw="2.5">
                    <div @click="addUser(index)">
                      <span v-if="x.user.length == 0" style="color: #bbb">请选择</span>
                      <span v-for="(y, index1) in x.user" :key="index1">{{
                        y.name
                      }}
                        <Icon type="md-close-circle" @click.stop="x.user.splice(index1, 1)" />
                      </span>
                    </div>
                    <Icon v-if="false" type="md-close-circle" @click="x.user = []" />
                  </ly-form-item>
                  <ly-form-item v-show="x.type == 1" label="职责" lw="2.5">
                    <Select style="width: 100%" v-model="x.rule1" multiple>
                      <Option value="qianzi">调度签字</Option>
                      <Option value="paichepaisiji">派车派司机</Option>
                      <Option value="jieshu">结束调度单</Option>
                      <Option value="feiyongqianzi">费用签字</Option>

                    </Select>
                  </ly-form-item>
                  <ly-form-item v-if="false" v-show="x.type == 1" label="自动" lw="2.5">
                    <i-switch v-model="x.isAuto">
                      <span slot="open">{{ $t("bool.true") }}</span>
                      <span slot="close">{{ $t("bool.false") }}</span>
                    </i-switch>
                  </ly-form-item>
                  <div class="pro_next">
                    <p v-if="x.type != 2">
                      <Icon type="md-arrow-down" />
                      <Input v-show="x.type == 1 && index != item.nodeList.length - 2
                        " v-model="x.nextLine"></Input>
                    </p>
                    <p v-show="x.type == 1 && index != item.nodeList.length - 2
                      ">
                      <Icon type="md-arrow-up" />
                      <Input ref="perLine" v-model="x.perLine"></Input>
                    </p>
                  </div>
                </li>
              </ul>
            </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div style="width: 260px; float: right">
        <Button @click="save('item')" type="primary" long>提交保存</Button>
      </div>
    </Drawer>
    <Drawer class="my-drawer" title="添加角色" :closable="false" :width="240" v-model="openRole">
      <roleList v-if="openRole" @role="reRole"></roleList>
    </Drawer>
    <Drawer class="my-drawer" title="添加用户" :closable="false" :width="240" v-model="openUser">
      <userTree @user="reUser" noFill></userTree>
    </Drawer>
  </div>
</template>
<script>
import roleList from "./roleList.vue";
export default {
  components: { roleList },
  data() {
    return {
      openForm: false,
      openRole: false,
      openUser: false,
      isAdd: true,
      width: 700,
      item: {
        isAuto: false,
        isPublic: 0,
        serverUrl: "",
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        serverUrl: { required: true, message: "必填" },
        groupName: { required: true, message: "必填" },
      },
    };
  },
  methods: {
    open(isAdd, data) {
      this.isAdd = isAdd;
      this.openForm = true;
      if (isAdd) {
        var v = {
          groupId: "",
          groupName: "",
          name: "",
          content: "",
          serverUrl: "",
          moduleTable: "",
          status: "0",
          tag: [],
          isPublic: 0,
          ver: 1,
          nodeList: [
            {
              name: "开始",
              content: "",
              nextLine: "",
              perLine: "",
              role: [],
              user: [],
              rule1: [],
              type: 0,
            },
            {
              name: "节点名称1",
              content: "",
              nextLine: "分派",
              perLine: "驳回",
              role: [],
              user: [],
              rule1: [],
              type: 1,
            },
            {
              name: "节点名称2",
              content: "",
              nextLine: "分派",
              perLine: "驳回",
              role: [],
              rule1: [],
              user: [],
              type: 1,
            },
            {
              name: "节点名称3",
              content: "",
              nextLine: "验收",
              perLine: "驳回",
              role: [],
              user: [],
              type: 1,
            },
            {
              name: "结束",
              content: "",
              nextLine: "",
              perLine: "",
              role: [],
              user: [],
              type: 2,
            },
          ],
        };
        this.getnode(v);
      } else {
        this.getnode(data);
      }
    },
    addPross(index) {
      var obj = {
        name: "节点名称",
        nextLine: "分派",
        perLine: "驳回",
        content: "任务描述",
        role: [],
        user: [],
        type: 1,
      };

      this.item.nodeList.splice(index, 0, obj);
    },
    delPross(index) {
      if (this.item.nodeList.length <= 3) {
        this.$Message.error("至少保留一个节点");
      } else {
        this.item.nodeList.splice(index, 1);
      }
    },
    addRole(index) {
      this.openRole = true;
      this.openRole = true;
      this.activeIndex = index;
    },
    addUser(index) {
      this.openUser = true;
      this.activeIndex = index;
    },
    reRole(x) {
      var m = this.item.nodeList[this.activeIndex].role;
      for (let i = 0; i < m.length; i++) {
        if (m[i].id == x.id) {
          this.$Message.error("重复添加");
          return;
        }
      }
      m.push(x);
    },
    reUser(x) {
      var m = this.item.nodeList[this.activeIndex].user;
      for (let i = 0; i < m.length; i++) {
        if (m[i].accountId == x.accountId) {
          this.$Message.error("重复添加");
          return;
        }
      }
      m.push(x);
    },
    getnode(data) {
      var x = data.nodeList;

      for (const i in x) {
        x[i].rule1 = this.utils.isEmpty(x[i].rule) ? [] : x[i].rule.split(",");
      }
      this.item = data;
    },
    save(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var m = this.item.nodeList;
          for (let i = 0; i < m.length; i++) {
            m[i].rule = m[i].rule1.join(",");
            if (m[i].type == 0) {
              m[i].id = "E001";
            } else if (m[i].type == 2) {
              m[i].id = "E002";
            } else {
              m[i].id = "T00" + i;
            }
            //把倒数第一个的前进与返回清空
            if (i == m.length - 2) {
              m[i].nextLine = "";
              m[i].perLine = "";
            }
          }
          console.log(this.item);
          this.$emit("item", this.item);
          this.openForm = false;
        }
      });
    },
  },

  mounted() { },
};
</script>
<style lang="">
#nodeList {
  width: 100%;
  margin-bottom: 18px;
  margin-top: 10px;
}
#acewdsc {
  height: calc(100% - 40px);
  overflow: auto;
  overflow-x: hidden;
}
#nodeList li {
  margin-bottom: 10px;
}
#nodeList li .lyformitem {
  margin-bottom: 0px;
  cursor: pointer;
  margin-left: 6px;
}
#nodeList li .lyformitem > p > div {
  width: calc(100% - 26px);
  display: inline-block;
  margin-right: 4px;
  display: flex;
  flex-wrap: wrap;
}
#nodeList li .lyformitem > p > div:hover {
  background: #e0edf7;
}
#nodeList li .lyformitem > p > div > span {
  margin-right: 6px;
  display: block;
}
#nodeList li .lyformitem > p > div > span > i {
  font-size: 16px;
  display: none;
}
#nodeList li .lyformitem:hover > p > div > span > i {
  display: inline;
}
#nodeList input {
  border: none;
}
#nodeList input:active {
  outline: none;
}
#nodeList .nodeListTitle {
  width: 160px;
}
#nodeList .nodeListTitle input {
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
}
#nodeList .nodeListContent input {
  margin-top: -4px;
}
#nodeList .pro_next {
  display: flex;
}
#nodeList .pro_next > p {
  display: flex;
  margin-right: 10px;
}
#nodeList .pro_next > p i {
  font-size: 20px;
  margin-top: 6px;
  color: #888;
}
#nodeList .pro_next > p input {
  width: 70px;
}
.acsdecwe li {
  cursor: pointer;
  padding: 10px 4px;
}
.acsdecwe li.active,
.acsdecwe li:hover {
  background: #e4ebfd;
}
.right350 .ivu-drawer-right {
  right: 240px;
}
</style>


// WEBPACK FOOTER //
// src/components/diaodu/liuchengTool.vue